import { app } from '../../../app';
import { Controller } from './saml-logout.controller';

app.component('samlLogout', {
    templateUrl: require('./saml-logout.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/saml-logout/saml-logout.component.js